import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';






import {
    Title,
    PanelBox,
    MonitoringServiceState,
    StackedBarChart,
} from '../../components/Display';
import { postData } from '../../Api';
import { Grid, GridColumn } from '../../components/Layout';

export default function Home(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [postRegistration, setPostRegistration] = useState({ lastSuccess: '', description: '', alert: false });
    useEffect(() => {
        postData('/api/panel/page/monitoring-service-state/taroff-post-registration').then(
            (response) => {
                setPostRegistration({
                    lastSuccess: response.lastSuccess || '',
                    description: response.description || '',
                    alert: !!response.alert,
                });
            }
        );
    }, []);
    const [monitoringTaroffServiceSyncLastSuccess, setMonitoringTaroffServiceSyncLastSuccess] =
        useState('');
    useEffect(() => {
        postData('/api/panel/page/monitoring-service-state/taroff-service-sync').then(
            (response) => {
                setMonitoringTaroffServiceSyncLastSuccess(response.lastSuccess);
            }
        );
    }, []);
    const [monitoringTaroffServiceOrdersLastSuccess, setMonitoringTaroffServiceOrdersLastSuccess] =
        useState('');
    useEffect(() => {
        postData('/api/panel/page/monitoring-service-state/taroff-service-orders').then(
            (response) => {
                setMonitoringTaroffServiceOrdersLastSuccess(response.lastSuccess);
            }
        );
    }, []);
    const [
        monitoringPargarDatabaseBackupLastSuccess,
        setMonitoringPargarDatabaseBackupLastSuccess,
    ] = useState('');
    useEffect(() => {
        postData('/api/panel/page/monitoring-service-state/pargar-database-backup').then(
            (response) => {
                setMonitoringPargarDatabaseBackupLastSuccess(response.lastSuccess);
            }
        );
    }, []);
    const [
        monitoringTaroffServiceGatewayLastSuccess,
        setMonitoringTaroffServiceGatewayLastSuccess,
    ] = useState('');
    useEffect(() => {
        postData('/api/panel/page/monitoring-service-state/taroff-service-gateway').then(
            (response) => {
                setMonitoringTaroffServiceGatewayLastSuccess(response.lastSuccess);
            }
        );
    }, []);
    const [
        monitoringTaroffServiceOtherOrdersLastSuccess,
        setMonitoringTaroffServiceOtherOrdersLastSuccess,
    ] = useState('');
    useEffect(() => {
        postData('/api/panel/page/monitoring-service-state/taroff-service-other-orders').then(
            (response) => {
                setMonitoringTaroffServiceOtherOrdersLastSuccess(response.lastSuccess);
            }
        );
    }, []);
    const [
        monitoringTaroffServicePeikOptimeCreateLastSuccess,
        setMonitoringTaroffServicePeikOptimeCreateLastSuccess,
    ] = useState('');
    useEffect(() => {
        postData(
            '/api/panel/page/monitoring-service-state/taroff-service-peik-optime-create'
        ).then((response) => {
            setMonitoringTaroffServicePeikOptimeCreateLastSuccess(response.lastSuccess);
        });
    }, []);
    const [
        monitoringTaroffServicePeikOptimeAssignLastSuccess,
        setMonitoringTaroffServicePeikOptimeAssignLastSuccess,
    ] = useState('');
    useEffect(() => {
        postData(
            '/api/panel/page/monitoring-service-state/taroff-service-peik-optime-assign'
        ).then((response) => {
            setMonitoringTaroffServicePeikOptimeAssignLastSuccess(response.lastSuccess);
        });
    }, []);
    const [
        monitoringTaroffServicePeikOptimeCheckLastSuccess,
        setMonitoringTaroffServicePeikOptimeCheckLastSuccess,
    ] = useState('');
    useEffect(() => {
        postData('/api/panel/page/monitoring-service-state/taroff-service-peik-optime-check').then(
            (response) => {
                setMonitoringTaroffServicePeikOptimeCheckLastSuccess(response.lastSuccess);
            }
        );
    }, []);
    const [chartDataS93, setChartDataS93] = useState({ data: [], categories: [] });
    useEffect(() => {
        postData('/api/panel/page/chart-data/s93').then((response) => {
            setChartDataS93({ data: response.data, categories: response.categories });
        });
    }, []);
    return (
        <PanelBox>
            <Title>داشبورد مدیریت تعارف</Title>
            {postRegistration.alert && (
                <div
                    dir="rtl"
                    className="my-2 p-3 rounded-md border border-red-400 bg-red-50 dark:bg-red-900 dark:border-red-600 text-red-700 dark:text-red-200 text-sm font-bold"
                >
                    <bdi>{postRegistration.description}</bdi>
                </div>
            )}
            <Grid>
                <GridColumn width={4}>
                    <MonitoringServiceState
                        title={'ثبت مرسوله در پست'}
                        description={
                            postRegistration.description ||
                            'آخرین قیمت‌گذاری موفق ثبت مرسوله در پست؛ قدیمی شدن آن در شب‌های کم‌ترافیک طبیعی است.'
                        }
                        redStateTimeout={720}
                        yellowStateTimeout={360}
                        lastSuccess={postRegistration.lastSuccess}
                        alert={postRegistration.alert}
                    />
                </GridColumn>
                <GridColumn width={4}>
                    <MonitoringServiceState
                        title={'پروسه بررسی وضعیت'}
                        description={
                            'بررسی وضعیت سفارشات، ارسال به گیت وی، ایجاد تراکنش ها و ارسال پیامک تغییر وضعیت'
                        }
                        redStateTimeout={10}
                        yellowStateTimeout={5}
                        lastSuccess={monitoringTaroffServiceSyncLastSuccess}
                    />
                </GridColumn>
                <GridColumn width={4}>
                    <MonitoringServiceState
                        title={'پروسه وضعیت آماده ارسال'}
                        description={'بررسی وضعیت سفارشات پستی آماده ارسال'}
                        redStateTimeout={30}
                        yellowStateTimeout={15}
                        lastSuccess={monitoringTaroffServiceOrdersLastSuccess}
                    />
                </GridColumn>
                <GridColumn width={4}>
                    <MonitoringServiceState
                        title={'بک آپ از دیتابیس'}
                        description={'پشتیبان گیری از اطلاعات دیتابیس در سرور ثالث برای موارد اضطراری'}
                        redStateTimeout={360}
                        yellowStateTimeout={180}
                        lastSuccess={monitoringPargarDatabaseBackupLastSuccess}
                    />
                </GridColumn>
                <GridColumn width={4}>
                    <MonitoringServiceState
                        title={'پروسه وضعیت گیت وی روز های اخیر'}
                        description={'بررسی وضعیت سفارشات پستی روزهای گذشته از سرویس گیت وی'}
                        redStateTimeout={240}
                        yellowStateTimeout={120}
                        lastSuccess={monitoringTaroffServiceGatewayLastSuccess}
                    />
                </GridColumn>
                <GridColumn width={4}>
                    <MonitoringServiceState
                        title={'پروسه وضعیت گیت وی سفارشات'}
                        description={'بررسی وضعیت سفارشات پستی در وضعیت های پس از آماده ارسال'}
                        redStateTimeout={240}
                        yellowStateTimeout={120}
                        lastSuccess={monitoringTaroffServiceOtherOrdersLastSuccess}
                    />
                </GridColumn>
                <GridColumn width={4}>
                    <MonitoringServiceState
                        title={'پروسه ساخت پلن های آپتایم'}
                        description={'بررسی سفارشات پیکی، ارسال به آپتایم'}
                        redStateTimeout={15}
                        yellowStateTimeout={8}
                        lastSuccess={monitoringTaroffServicePeikOptimeCreateLastSuccess}
                    />
                </GridColumn>
                <GridColumn width={4}>
                    <MonitoringServiceState
                        title={'پروسه انتساب پلن ها به پیک ها'}
                        description={'بررسی سفارشات پیکی، انتساب پلن ها به پیک ها'}
                        redStateTimeout={15}
                        yellowStateTimeout={8}
                        lastSuccess={monitoringTaroffServicePeikOptimeAssignLastSuccess}
                    />
                </GridColumn>
                <GridColumn width={4}>
                    <MonitoringServiceState
                        title={'پروسه بررسی وضعیت پلن های آپتایم'}
                        description={'بررسی سفارشات پیکی از آپتایم'}
                        redStateTimeout={30}
                        yellowStateTimeout={15}
                        lastSuccess={monitoringTaroffServicePeikOptimeCheckLastSuccess}
                    />
                </GridColumn>
            </Grid>
            <StackedBarChart data={chartDataS93.data} categories={chartDataS93.categories} />
            {modal && modal}
        </PanelBox>
    );
}
